// extracted by mini-css-extract-plugin
export var appDownloadLink = "StoresBlock-module--appDownloadLink--03e88";
export var desktop = "StoresBlock-module--desktop--614b0";
export var mobile = "StoresBlock-module--mobile--2aad4";
export var wrapper = "StoresBlock-module--wrapper--55c6a";